import React from 'react';

import { PillarOneSliderScoreWorkspace } from './PillarOneSliderDirectionWorkspace';
import type { PillarOneSliderWorkspaceProps } from './PillarOneSliderDirectionWorkspace';

const PillarOneRestraintWorkspace: React.FC<
  PillarOneSliderWorkspaceProps
> = props => <PillarOneSliderScoreWorkspace {...props} mode="restraint" />;

export default PillarOneRestraintWorkspace;
